import React from 'react';
import { FaArrowRight, FaCheckCircle, FaClock, FaShieldAlt, FaStar } from 'react-icons/fa';
import nurse from '../../assets/nrs_img.png'
import { Link } from 'react-router-dom';

const HeroSection = () => {
    return (
        <section className="relative overflow-hidden hero-gradient pt-4 pb-12 md:pt-8 md:pb-12 px-6 -mt-4">
            <div className="md:mx-auto px-4 grid md:grid-cols-2 gap-12 items-center">

                <div className="relative">
                    {/* Badge */}
                    <span className="inline-flex items-center px-4 py-1.5 rounded-full bg-primary/10 text-primary text-xs font-bold uppercase tracking-wider mb-6">
                        <span className="size-2 rounded-full bg-primary mr-2 animate-pulse"></span>
                        Quality Care at Your Doorstep
                    </span>

                    <h1 className="text-3xl md:text-5xl font-black text-text-main dark:text-white leading-[1.1] mb-6 tracking-tight">
                        Compassionate <span className="text-primary">care</span> delivered at home.
                    </h1>

                    <p className="text-lg md:text-xl text-text-secondary dark:text-slate-400 mb-8 leading-relaxed">
                        Connect with certified medical professionals who bring hospital-grade nursing care to the comfort and safety of your own house.
                    </p>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
                        <div className="flex items-start gap-3 p-3 rounded-xl bg-white/50 dark:bg-slate-800/50 backdrop-blur-sm">
                            <div className="size-10 rounded-lg bg-primary/10 text-primary flex items-center justify-center flex-shrink-0">
                                <FaCheckCircle className="text-lg" />
                            </div>
                            <div>
                                <p className="font-bold text-slate-900 dark:text-white text-sm">Vetted Professionals</p>
                                <p className="text-xs text-slate-600 dark:text-slate-400">Every nurse background-checked</p>
                            </div>
                        </div>

                        <div className="flex items-start gap-3 p-3 rounded-xl bg-white/50 dark:bg-slate-800/50 backdrop-blur-sm">
                            <div className="size-10 rounded-lg bg-green-500/10 text-green-600 flex items-center justify-center flex-shrink-0">
                                <FaClock className="text-lg" />
                            </div>
                            <div>
                                <p className="font-bold text-slate-900 dark:text-white text-sm">Same-Day Service</p>
                                <p className="text-xs text-slate-600 dark:text-slate-400">Book within hours</p>
                            </div>
                        </div>

                        <div className="flex items-start gap-3 p-3 rounded-xl bg-white/50 dark:bg-slate-800/50 backdrop-blur-sm">
                            <div className="size-10 rounded-lg bg-blue-500/10 text-blue-600 flex items-center justify-center flex-shrink-0">
                                <FaShieldAlt className="text-lg" />
                            </div>
                            <div>
                                <p className="font-bold text-slate-900 dark:text-white text-sm">Safe & Secure</p>
                                <p className="text-xs text-slate-600 dark:text-slate-400">Your privacy is our priority</p>
                            </div>
                        </div>

                        <div className="flex items-start gap-3 p-3 rounded-xl bg-white/50 dark:bg-slate-800/50 backdrop-blur-sm">
                            <div className="size-10 rounded-lg bg-yellow-500/10 text-yellow-600 flex items-center justify-center flex-shrink-0">
                                <FaStar className="text-lg" />
                            </div>
                            <div>
                                <p className="font-bold text-slate-900 dark:text-white text-sm">Top-Rated Care</p>
                                <p className="text-xs text-slate-600 dark:text-slate-400">5-star quality guaranteed</p>
                            </div>
                        </div>
                    </div>

                    <div className="mb-10">
                        <p className="text-text-secondary text-lg md:text-xl dark:text-slate-400 leading-relaxed">
                            From routine check-ups to specialized procedures, we match you with qualified nurses
                            who understand your unique health requirements. Professional care, right where you are.
                        </p>
                    </div>

                    <div className="flex flex-col sm:flex-row gap-4 mb-8">
                        <button
                            onClick={() => {
                                const patientSection = document.getElementById('patient-process')
                                if (patientSection) patientSection.scrollIntoView({ behavior: 'smooth' })
                            }}
                            className="h-14 px-8 bg-primary text-white rounded-xl font-bold text-lg hover:bg-primary/90 transition-all shadow-lg hover:shadow-primary/30 flex items-center justify-center gap-2">
                            Find a Nurse
                            <FaArrowRight />
                        </button>
                        <Link to={'/about#for-nurses'}  className="h-14 px-8 bg-white dark:bg-slate-800 border-2 border-border-color dark:border-slate-700 text-text-main dark:text-white rounded-xl font-bold text-lg hover:bg-slate-50 dark:hover:bg-slate-700 transition-all flex items-center justify-center">
                            Register as Nurse
                        </Link>
                    </div>

                    <div className="flex flex-wrap items-center gap-6 text-sm">
                        <div className="flex items-center gap-2">
                            <div className="flex text-primary">
                                <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
                            </div>
                            <span className="text-text-secondary dark:text-slate-400 font-medium">New & Growing</span>
                        </div>
                        <div className="h-4 w-px bg-border-color dark:bg-slate-700"></div>

                    </div>
                </div>

                <div className="relative">
                    <div className="absolute -top-12 -right-12 size-64 bg-primary/10 rounded-full blur-3xl"></div>
                    <div className="absolute -bottom-12 -left-12 size-64 bg-blue-400/10 rounded-full blur-3xl"></div>

                    <div className="relative rounded-3xl overflow-hidden shadow-2xl transform rotate-1">
                        <img
                            alt="Professional Nurse Care"
                            className="w-full h-full object-cover aspect-[4/5] md:aspect-[4/4]"
                            src={nurse}
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>

                        <div className="absolute bottom-6 left-6 right-6 glass-card p-6 rounded-2xl shadow-xl border border-white/20">
                            <div className="flex items-center gap-4">
                                <div className="size-12 rounded-full bg-green-500/20 text-green-600 flex items-center justify-center">
                                    <FaCheckCircle className="text-2xl font-bold" />
                                </div>
                                <div>
                                    <p className="font-bold text-slate-900">Certified Professionals</p>
                                    <p className="text-sm text-slate-600">All nurses are fully vetted and background checked.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HeroSection;